import React, { useCallback, useEffect, useState, useRef } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { AppBar,Tab,Tabs as MuiTabs,Tooltip } from '@material-ui/core';


import { TabPanel } from '.';
import generateId from '../../utils/generateId';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tabPanel: {
    backgroundColor: theme.palette.neutral.light2,
    flexGrow: 1,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  }
}));

export const Tabs = ({children, ...props}) => {
  const classes = useStyles();
  const [id] = useState(generateId('tab-'));
  
  const tabsActions = useRef();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `${id}-tab-${index}`,
      'aria-controls': `${id}-tabpanel-${index}`,
    };
  }

  const updateIndicator = useCallback(() => {
    if (tabsActions.current) {
      tabsActions.current.updateIndicator()
    }
  }, [tabsActions])

  useEffect(() => {
    window.addEventListener('splitDragEnd',updateIndicator);
    return () => { window.removeEventListener('splitDragEnd', updateIndicator) }
  }, [updateIndicator])

  return (
    <div className={classes.root}>
      
      <AppBar position="relative">
        <MuiTabs
          action={tabsActions}
          centered 
          value={value} 
          onChange={handleChange} 
          indicatorColor="primary"
          textColor="primary"
        >
          {React.Children.map(children, (child, index) => (
            <Tooltip title={child.props.title} arrow interactive>
              <Tab label={child.props.label} {...a11yProps(index)} />
            </Tooltip>
          ))}
        </MuiTabs>
      </AppBar>
      {React.Children.map(children, (child,index) => (
        <TabPanel value={value} index={index} id={id} className={classes.tabPanel}>
          {child.props.children}
        </TabPanel>
      ))}
  
    </div>
  );
}
